<script>
import axios from 'axios'

export default {
    data() {
        return {
            state: 'unsubmitted',
            message: {
                name: '',
                email: '',
                dealer_name: '',
                dealer_address: '',
                agree_materials: false,
                agree_local_initiatives: false,
                agree_offset_emissions: false
            },
            form: {
                customer: {
                    owner: '',
                    email: '',
                    name: '',
                    address: '',
                },
                agreement: {
                    recycles: false,
                    local_initiatives: false,
                    offset_emissions: false
                }
            },
            errors: {},
            program_1_open: true,
            program_2_open: false,
            program_3_open: false,
        }
    },
    mounted() {
    },
    props: ['csrfToken', 'csrfTokenName'],
    computed: {
        unsubmitted() {
            return this.state === 'unsubmitted'
        },
        sending() {
            return this.state === 'sending'
        },
        sent() {
            return this.state === 'sent'
        },
        api() {
            return axios.create({
                headers: {
                    'Authorization': 'Token token=' + this.token,
                }
            })
        },
        submitEnabled() {
            return ((this.form.agreement.recycles || this.form.agreement.local_initiatives || this.form.agreement.offset_emissions) && this.form.customer.owner.length && this.form.customer.email.length && this.form.customer.name.length && this.form.customer.address)
        }
    },
    methods: {
        submit() {
            this.form[this.csrfTokenName] = this.csrfToken;
            this.state = 'sending'
            this.api.post('/api/eco-signup', this.form)
                .then((response) => {
                    if (response.data.statusCode === 200) {
                        this.state = 'sent'
                    } else {
                        this.errors = response.data.body.error
                        this.state = 'unsubmitted'
                    }
                }, (error) => {
                    this.state = 'unsubmitted'
                })
        },
        hasError(field) {
            let data = false
            for (let key of Object.keys(this.errors))
            {
                if (field === key)
                {
                    data = true
                    break
                }
            }
            return data
        },
        unsetForm() {
            this.message = {
                name: '',
                email: '',
                dealer_name: '',
                dealer_address: '',
                agree_materials: false,
                agree_local_initiatives: false,
                agree_offset_emissions: false,
            }
            this.state = 'unsubmitted'
        },
        toggleProgramOne() {
            this.program_1_open = this.program_1_open ? false : true
        },
        toggleProgramTwo() {
            this.program_2_open = this.program_2_open ? false : true
        },
        toggleProgramThree() {
            this.program_3_open = this.program_3_open ? false : true
        }
    }
}
</script>
